import {useSelector} from 'react-redux';
import {itemPageLoadingStatusSelector} from './../store';

export function usePageLoading() {
  const {loading: pageLoading, loadingPageSection} = useSelector(itemPageLoadingStatusSelector);
  return {pageLoading, loadingPageSection};
}
